import main from '../views/main/main.vue';
// 接口传递的页面
//cName 需与后台配置中文名一致 用来高亮菜单栏用
const childenRoute = [
  {
    path: '/report_forms',
    name: 'report_forms',
    component: resolve => {
      require(['../views/sys/ReportForms.vue'], resolve);
    },
    meta: {
      title: '首页',
      cName: '首页',
    },
  },
  {
    path: '/advertisement',
    name: 'advertisement',
    component: resolve => {
      require(['../views/sys/advertisement.vue'], resolve);
    },
    meta: {
      title: '广告管理',
      cName: '广告管理',
    },
  },
  {
    path: '/Usermanage',
    name: 'Usermanage',
    component: resolve => {
      require(['../views/bank/Usermanage.vue'], resolve);
    },
    meta: {
      title: '用户管理',
      cName: '用户管理',
    },
  },
  {
    path: '/Repairnetwork',
    name: 'Repairnetwork',
    component: resolve => {
      require(['../views/bank/Repairnetwork.vue'], resolve);
    },
    meta: {
      title: '维修网点',
      cName: '维修网点',
    },
  },
  {
    path: '/Separateaccounts',
    name: 'Separateaccounts',
    component: resolve => {
      require(['../views/bank/Separateaccounts.vue'], resolve);
    },
    meta: {
      title: '分账商户管理',
      cName: '分账商户管理',
    },
  },
  {
    path: '/Financialmanagement',
    name: 'Financialmanagement',
    component: resolve => {
      require(['../views/bank/Financialmanagement.vue'], resolve);
    },
    meta: {
      title: '订单列表',
      cName: '订单列表',
    },
  },
  {
    path: '/chargeaccount',
    name: 'chargeaccount',
    component: resolve => {
      require(['../views/bank/chargeaccount.vue'], resolve);
    },
    meta: {
      title: '挂账管理',
      cName: '挂账管理',
    },
  },
  {
    path: '/Order_allocation',
    name: 'Order_allocation',
    component: resolve => {
      require(['../views/bank/Order_allocation.vue'], resolve);
    },
    meta: {
      title: '订单分账明细',
      cName: '订单分账明细',
    },
  },
  
  {
    path: '/Receipt_details',
    name: 'Receipt_details',
    component: resolve => {
      require(['../views/bank/Receipt_details.vue'], resolve);
    },
    meta: {
      title: '分账方到账明细',
      cName: '分账方到账明细',
    },
  },
  {
    path: '/quanlist',
    name: 'quanlist',
    component: resolve => {
      require(['../views/quan/quanlist.vue'], resolve);
    },
    meta: {
      title: '优惠券管理',
      cName: '优惠券管理',
    },
  },
  {
    path: '/quanhistroy',
    name: 'quanhistroy',
    component: resolve => {
      require(['../views/quan/quanhistroy.vue'], resolve);
    },
    meta: {
      title: '用户优惠券明细',
      cName: '用户优惠券明细',
    },
  },
  {
    path: '/Abnormalstatistics',
    name: 'Abnormalstatistics',
    component: resolve => {
      require(['../views/bank/Abnormalstatistics.vue'], resolve);
    },
    meta: {
      title: '桩异常统计',
      cName: '桩异常统计',
    },
  },
  {
    path: '/ServiceItems',
    name: 'ServiceItems',
    component: resolve => {
      require(['../views/sys/ServiceItems.vue'], resolve);
    },
    meta: {
      title: '服务项目管理',
      cName: '服务项目管理',
    },
  },
  {
    path: '/Engineermanagement',
    name: 'Engineermanagement',
    component: resolve => {
      require(['../views/bank/Engineermanagement.vue'], resolve);
    },
    meta: {
      title: '工程师列表',
      cName: '工程师列表',
    },
  },
  {
    path: '/Merchantregistration',
    name: 'Merchantregistration',
    component: resolve => {
      require(['../views/bank/Merchantregistration.vue'], resolve);
    },
    meta: {
      title: '入驻商户列表',
      cName: '入驻商户列表',
    },
  },
  {
    path: '/auth_admin',
    name: 'auth_admin',
    component: resolve => {
      require(['../views/auth/Admin.vue'], resolve);
    },
    meta: {
      title: '系统设置 / 管理员管理',
      cName: '管理员管理',
    },
  },
  {
    path: '/auth_menu',
    name: 'auth_menu',
    component: resolve => {
      require(['../views/auth/Menu.vue'], resolve);
    },
    meta: {
      title: '系统管理 / 菜单管理',
      cName: '菜单管理',
    },
  },
  {
    path: '/auth_role',
    name: 'auth_role',
    component: resolve => {
      require(['../views/auth/Role.vue'], resolve);
    },
    meta: {
      title: '系统管理 / 角色管理',
      cName: '角色管理',
    },
  },
  {
    path: '/coustomPhone',
    name: 'coustomPhone',
    component: resolve => {
      require(['../views/sys/coustomPhone.vue'], resolve);
    },
    meta: {
      title: '系统管理 / 客服电话',
      cName: '客服电话',
    },
  },
  {
    path: '/transfer_approval_auth',
    name: 'transfer_approval_auth',
    component: resolve => {
      require(['../views/auth/TransferApproval.vue'], resolve);
    },
    meta: {
      title: '系统管理 / 权限管理',
      cName: '权限管理',
    },
  },
  {
    path: '/bank_account_management',
    name: 'bank_account_management',
    component: resolve => {
      require(['../views/bank/AccountManagement.vue'], resolve);
    },
    meta: {
      title: '银企直联 / 账户管理',
      cName: '账户管理',
    },
  },
  {
    path: '/account_details_query',
    name: 'account_details_query',
    component: resolve => {
      require(['../views/bank/AccountDetailsQuery.vue'], resolve);
    },
    meta: {
      title: '银企直联 / 商户明细查询',
      cName: '商户明细查询',
    },
  },
  {
    path: '/bank_transfer_management',
    name: 'bank_transfer_management',
    component: resolve => {
      require(['../views/bank/TransferManagement.vue'], resolve);
    },
    meta: {
      title: '银企直联 / 转账管理',
      cName: '转账管理',
    },
  },
  {
    path: '/bank_enterprise_direct_link_setting',
    name: 'bank_enterprise_direct_link_setting',
    component: resolve => {
      require(['../views/bank/BankEnterpriseDirectLinkSetting.vue'], resolve);
    },
    meta: {
      title: '银企直联 / 银企直联设置',
      cName: '银企直联设置',
    },
  },

  {
    path: '/bank_transfer_records',
    name: 'bank_transfer_records',
    component: resolve => {
      require(['../views/bank/TransferRecords.vue'], resolve);
    },
    meta: {
      title: '银企直联 / 转账记录',
      cName: '转账记录',
    },
  },
  {
    path: '/bank_transfer_sum_records',
    name: 'bank_transfer_sum_records',
    component: resolve => {
      require(['../views/bank/TransferSumRecords.vue'], resolve);
    },
    meta: {
      title: '银企直联 / 转账记录汇总表',
      cName: '转账记录汇总表',
    },
  },

  {
    path: '/sys_ledger_config',
    name: 'sys_ledger_config',
    component: resolve => {
      require(['../views/ledger/LedgerConfig.vue'], resolve);
    },
    meta: {
      title: '系统管理 / 分账配置',
      cName: '分账配置',
    },
  },
  {
    path: '/sys_ledger_template',
    name: 'sys_ledger_template',
    component: resolve => {
      require(['../views/ledger/LedgerTemplate.vue'], resolve);
    },
    meta: {
      title: '系统管理 / 分账方案',
      cName: '分账方案',
    },
  },
  {
    path: '/sys_channel',
    name: 'sys_channel',
    component: resolve => {
      require(['../views/sys/Channel.vue'], resolve);
    },
    meta: {
      title: '系统管理 / 品牌管理',
      cName: '品牌管理',
    },
  },
  {
    path: '/sys_trade_area',
    name: 'sys_trade_area',
    component: resolve => {
      require(['../views/sys/TradeArea.vue'], resolve);
    },
    meta: {
      title: '系统管理 / 大区管理',
      cName: '大区管理',
    },
  },
  {
    path: '/sys_trade_range',
    name: 'sys_trade_range',
    component: resolve => {
      require(['../views/sys/TradeRange.vue'], resolve);
    },
    meta: {
      title: '系统管理 / 区域管理',
      cName: '区域管理',
    },
  },
  {
    path: '/ledger_project_management',
    name: 'ledger_project_management',
    component: resolve => {
      require(['../views/ledger/LedgerProjectManagement.vue'], resolve);
    },
    meta: {
      title: '系统管理 / 分账费项管理',
      cName: '分账费项管理',
    },
  },
  {
    path: '/multidimensional_merchant_management',
    name: 'multidimensional_merchant_management',
    component: resolve => {
      require(['../views/multidimensional/MultidimensionalMerchantManagement.vue'], resolve);
    },
    meta: {
      title: '系统管理 / 多维商户管理',
      cName: '多维商户管理',
    },
  },
  {
    path: '/kingdee_cloud_merchant_management',
    name: 'kingdee_cloud_merchant_management',
    component: resolve => {
      require(['../views/kingdee/KingdeeCloudMerchantManagement.vue'], resolve);
    },
    meta: {
      title: '系统管理 / 金蝶云商户管理',
      cName: '金蝶云商户管理',
    },
  },
  {
    path: '/merchant_ID_association',
    name: 'merchant_ID_association',
    component: resolve => {
      require(['../views/ledger/MerchantIDAssociation.vue'], resolve);
    },
    meta: {
      title: '系统管理 / 入账商户ID关联',
      cName: '入账商户ID关联',
    },
  },
  {
    path: '/sys_operation_log',
    name: ' ',
    component: resolve => {
      require(['../views/sys/OperationLog.vue'], resolve);
    },
    meta: {
      title: '系统管理 / 操作日志',
      cName: '操作日志',
    },
  },
  {
    path: '/accounting_channel_management',
    name: 'accounting_channel_management',
    component: resolve => {
      require(['../views/sys/AccountingChannelManagement.vue'], resolve);
    },
    meta: {
      title: '系统管理 / 入账渠道管理',
      cName: '入账渠道管理',
    },
  },
  {
    path: '/vendor_type',
    name: 'vendor_type',
    component: resolve => {
      require(['../views/sys/VendorType.vue'], resolve);
    },
    meta: {
      title: '系统管理 / 门店类型管理',
      cName: '门店类型管理',
    },
  },
  {
    path: '/ledger_vendor_management',
    name: 'ledger_vendor_management',
    component: resolve => {
      require(['../views/ledger/VendorManagement.vue'], resolve);
    },
    meta: {
      title: '分账管理 / 商户管理',
      cName: '商户管理',
    },
  },
  {
    path: '/ledger_vendor_registration',
    name: 'ledger_vendor_registration',
    component: resolve => {
      require(['../views/ledger/VendorRegistration.vue'], resolve);
    },
    meta: {
      title: '分账管理 / 商户注册',
      cName: '商户注册',
    },
  },

  {
    path: '/ledger_details_list1',
    name: 'ledger_details_list1',
    component: resolve => {
      require(['../views/ledger/LedgerDetailsList1.vue'], resolve);
    },
    meta: {
      title: '分账管理 / 分账明细',
      cName: '分账明细',
    },
  },
  {
    path: '/ledger_sum_list1',
    name: 'ledger_sum_list1',
    component: resolve => {
      require(['../views/reports/LedgerSumList1.vue'], resolve);
    },
    meta: {
      title: '分账管理 / 分账汇总报表',
      cName: '分账汇总报表',
    },
  },
  {
    path: '/ledger_failed_details_list',
    name: 'ledger_failed_details_list',
    component: resolve => {
      require(['../views/ledger/LedgerFailedDetailsList.vue'], resolve);
    },
    meta: {
      title: '分账管理 / 分账失败明细',
      cName: '分账失败明细',
    },
  },
  {
    path: '/revenue_report',
    name: 'revenue_report',
    component: resolve => {
      require(['../views/reports/RevenueReport.vue'], resolve);
    },
    meta: {
      title: '分账管理 / 收入报表',
      cName: '收入报表',
    },
  },
  {
    path: '/revenue_sum',
    name: 'revenue_sum',
    component: resolve => {
      require(['../views/reports/RevenueSum.vue'], resolve);
    },
    meta: {
      title: '分账管理 / 收入汇总报表',
      cName: '收入汇总报表',
    },
  },
  {
    path: '/order_refund_details',
    name: 'order_refund_details',
    component: resolve => {
      require(['../views/ledger/OrderRefundDetails.vue'], resolve);
    },
    meta: {
      title: '分账管理 / 订单退款明细',
      cName: '订单退款明细',
    },
  },
  {
    path: '/customer_wallet_management',
    name: 'customer_wallet_management',
    component: resolve => {
      require(['../views/ledger/CustomerWalletManagement.vue'], resolve);
    },
    meta: {
      title: '分账管理 / 客户钱包管理',
      cName: '客户钱包管理',
    },
  },
  {
    path: '/wallet_transaction_details',
    name: 'wallet_transaction_details',
    component: resolve => {
      require(['../views/ledger/WalletTransactionDetails.vue'], resolve);
    },
    meta: {
      title: '分账管理 / 客户钱包交易明细',
      cName: '客户钱包交易明细',
    },
  },
  {
    path: '/general_ledger_account_transfer_details',
    name: 'general_ledger_account_transfer_details',
    component: resolve => {
      require(['../views/ledger/GeneralLedgerAccountTransferDetails.vue'], resolve);
    },
    meta: {
      title: '分账管理 / 总账户划转明细',
      cName: '总账户划转明细',
    },
  },
  {
    path: '/general_ledger_account_transfer_sum',
    name: 'general_ledger_account_transfer_sum',
    component: resolve => {
      require(['../views/ledger/GeneralLedgerAccountTransferSum.vue'], resolve);
    },
    meta: {
      title: '分账管理 / 总账户划转汇总',
      cName: '总账户划转汇总',
    },
  },
  {
    path: '/vendor_binding_card',
    name: 'vendor_binding_card',
    component: resolve => {
      require(['../views/ledger/VendorBindingCard.vue'], resolve);
    },
    meta: {
      title: '分账管理 / 商户绑卡',
      cName: '商户绑卡',
    },
  },
  {
    path: '/reminder_of_abnormal_bill',
    name: 'reminder_of_abnormal_bill',
    component: resolve => {
      require(['../views/ledger/ReminderOfAbnormalBill.vue'], resolve);
    },
    meta: {
      title: '分账管理 / 分账异常提醒',
      cName: '分账异常提醒',
    },
  },
  {
    path: '/ledger_abnormal_data_report',
    name: 'ledger_abnormal_data_report',
    component: resolve => {
      require(['../views/reports/LedgerAbnormalDataReport.vue'], resolve);
    },
    meta: {
      title: '数据报表 / 分账异常数据报表',
      cName: '分账异常数据报表',
    },
  },
  {
    path: '/reconciliation_discrepancy_report',
    name: 'reconciliation_discrepancy_report',
    component: resolve => {
      require(['../views/reports/ReconciliationDiscrepancyReport.vue'], resolve);
    },
    meta: {
      title: '分账管理 / 对账差异报表',
      cName: '对账差异报表',
    },
  },
  {
    path: '/reconciliation_discrepancy_sum',
    name: 'reconciliation_discrepancy_sum',
    component: resolve => {
      require(['../views/reports/ReconciliationDiscrepancySum.vue'], resolve);
    },
    meta: {
      title: '分账管理 / 对账差异汇总',
      cName: '对账差异汇总',
    },
  },
  {
    path: '/multidimensional_field_management',
    name: 'multidimensional_field_management',
    component: resolve => {
      require(['../views/multidimensional/MultidimensionalFieldManagement.vue'], resolve);
    },
    meta: {
      title: '分账管理 / 凭证字段管理',
      cName: '凭证字段管理',
    },
  },
  {
    path: '/multidimensional_maintenance',
    name: 'multidimensional_maintenance',
    component: resolve => {
      require(['../views/multidimensional/MultidimensionalMaintenance.vue'], resolve);
    },
    meta: {
      title: '分账管理 / 多维字段维护',
      cName: '多维字段维护',
    },
  },
  {
    path: '/multidimensional_business_template',
    name: 'multidimensional_business_template',
    component: resolve => {
      require(['../views/multidimensional/MultidimensionalBusinessTemplate.vue'], resolve);
    },
    meta: {
      title: '分账管理 / 凭证模板',
      cName: '凭证模板',
    },
  },
  // {
  //   path: '/kingdee_maintenance',
  //   name: 'kingdee_maintenance',
  //   component: resolve => {
  //     require(['../views/kingdee/KingdeeMaintenance.vue'], resolve);
  //   },
  //   meta: {
  //     title: '分账管理 / 金蝶到账字段维护',
  //     cName: '金蝶到账字段维护',
  //   },
  // },
  {
    path: '/added_multidimensional_field_reminder',
    name: 'added_multidimensional_field_reminder',
    component: resolve => {
      require(['../views/multidimensional/AddedMultidimensionalFieldReminder.vue'], resolve);
    },
    meta: {
      title: '分账管理 / 新增凭证字段提醒',
      cName: '新增凭证字段提醒',
    },
  },
  {
    path: '/kingdee_voucher_settings',
    name: 'kingdee_voucher_settings',
    component: resolve => {
      require(['../views/kingdee/KingdeeVoucherSettings.vue'], resolve);
    },
    meta: {
      title: '分账管理 / 金蝶凭证设置',
      cName: '金蝶凭证设置',
    },
  },
  {
    path: '/business_type_voucher_reset_log',
    name: 'business_type_voucher_reset_log',
    component: resolve => {
      require(['../views/kingdee/BusinessTypeVoucherResetLog.vue'], resolve);
    },
    meta: {
      title: '分账管理 / 补推金蝶凭证',
      cName: '补推金蝶凭证',
    },
  },
  {
    path: '/kingdee_notify_error',
    name: 'kingdee_notify_error',
    component: resolve => {
      require(['../views/kingdee/KingdeeNotifyError.vue'], resolve);
    },
    meta: {
      title: '分账管理 / 金蝶凭证失败记录',
      cName: '金蝶凭证失败记录',
    },
  },
  {
    path: '/platform_balance_inquiry',
    name: 'platform_balance_inquiry',
    component: resolve => {
      require(['../views/ledger/PlatformBalanceInquiry.vue'], resolve);
    },
    meta: {
      title: '分账管理 / 平台余额查询',
      cName: '平台余额查询',
    },
  },
  {
    path: '/store_account_balance_inquiry',
    name: 'store_account_balance_inquiry',
    component: resolve => {
      require(['../views/ledger/StoreAccountBalanceInquiry.vue'], resolve);
    },
    meta: {
      title: '分账管理 / 门店登记薄余额查询',
      cName: '门店登记薄余额查询',
    }, // 门店账户余额查询
  },
  {
    path: '/account_transaction_details',
    name: 'account_transaction_details',
    component: resolve => {
      require(['../views/ledger/AccountTransactionDetails.vue'], resolve);
    },
    meta: {
      title: '分账管理 / 总账户入账明细',
      cName: '总账户入账明细',
    }, // 账户交易明细
  },
  {
    path: '/account_transaction_sum',
    name: 'account_transaction_sum',
    component: resolve => {
      require(['../views/ledger/AccountTransactionSum.vue'], resolve);
    },
    meta: {
      title: '分账管理 / 总账户入账汇总',
      cName: '总账户入账汇总',
    }, // 账户交易明细
  },
  {
    path: '/store_transaction_details1',
    name: 'store_transaction_details1',
    component: resolve => {
      require(['../views/ledger/StoreTransactionDetails1.vue'], resolve);
    },
    meta: {
      title: '分账管理 / 登记薄交易明细',
      cName: '登记薄交易明细',
    },
  },
  {
    path: '/store_transaction_sum1',
    name: 'store_transaction_sum1',
    component: resolve => {
      require(['../views/ledger/StoreTransactionSum1.vue'], resolve);
    },
    meta: {
      title: '分账管理 / 登记薄交易汇总',
      cName: '登记薄交易汇总',
    },
  },
  {
    path: '/store_transaction_details',
    name: 'store_transaction_details',
    component: resolve => {
      require(['../views/ledger/StoreTransactionDetails.vue'], resolve);
    },
    meta: {
      title: '分账管理 / 门店交易明细',
      cName: '门店交易明细',
    }, // 门店交易明细
  },
  {
    path: '/income_difference_report',
    name: 'income_difference_report',
    component: resolve => {
      require(['../views/reports/IncomeDifferenceReport.vue'], resolve);
    },
    meta: {
      title: '分账管理 / 收入差异报表',
      cName: '收入差异报表',
    },
  },
  {
    path: '/manual_accounting',
    name: 'manual_accounting',
    component: resolve => {
      require(['../views/ledger/ManualAccounting.vue'], resolve);
    },
    meta: {
      title: '分账管理 / 人工分账',
      cName: '人工分账',
    },
  },
  {
    path: '/manual_accounting_details',
    name: 'manual_accounting_details',
    component: resolve => {
      require(['../views/reports/ManualAccountingDetails.vue'], resolve);
    },
    meta: {
      title: '分账管理 / 人工分账明细',
      cName: '人工分账明细',
    },
  },
  {
    path: '/manual_accounting_sum',
    name: 'manual_accounting_sum',
    component: resolve => {
      require(['../views/reports/ManualAccountingSum.vue'], resolve);
    },
    meta: {
      title: '分账管理 / 人工分账汇总报表',
      cName: '人工分账汇总报表',
    },
  },
  {
    path: '/ledger_data_analysis',
    name: 'ledger_data_analysis',
    component: resolve => {
      require(['../views/reports/LedgerDataAnalysis.vue'], resolve);
    },
    meta: {
      title: '数据报表 / 分账数据分析',
      cName: '分账数据分析',
    },
  },
  {
    path: '/ledger_channel_data_analysis',
    name: 'ledger_channel_data_analysis',
    component: resolve => {
      require(['../views/reports/LedgerChannelDataAnalysis.vue'], resolve);
    },
    meta: {
      title: '数据报表 / 分账品牌数据分析',
      cName: '分账品牌数据分析',
    },
  },
  {
    path: '/ledger_data_report',
    name: 'ledger_data_report',
    component: resolve => {
      require(['../views/reports/LedgerDataReport.vue'], resolve);
    },
    meta: {
      title: '数据报表 / 分账数据报表',
      cName: '分账数据报表',
    },
  },
  {
    path: '/corporlink_data_analysis',
    name: 'corporlink_data_analysis',
    component: resolve => {
      require(['../views/reports/CorporlinkDataAnalysis.vue'], resolve);
    },
    meta: {
      title: '数据报表 / 银企直联数据分析',
      cName: '银企直联数据分析',
    },
  },
  {
    path: '/corporlink_data_report',
    name: 'corporlink_data_report',
    component: resolve => {
      require(['../views/reports/CorporlinkDataReport.vue'], resolve);
    },
    meta: {
      title: '数据报表 / 银企直联数据报表',
      cName: '银企直联数据报表',
    },
  },
];

export default [
  // {
  //   path: '*',
  //   redirect: '/index',
  // },
  {
    path: '/login',
    name: 'login',
    meta: {
      title: '登录',
      cName: '登录',
    },
    component: resolve => {
      require(['../views/login/login.vue'], resolve);
    }
  },
  {
    path: '/forgetPassword',
    name: 'forgetPassword',
    meta: {
      title: '忘记密码',
      cName: '忘记密码',
    },
    component: resolve => {
      require(['../views/login/forgetPassword.vue'], resolve);
    }
  },
  {
    path: '/changePassword',
    name: 'changePassword',
    meta: {
      title: '修改密码',
      cName: '修改密码',
    },
    component: resolve => {
      require(['../views/login/changePassword.vue'], resolve);
    }
  },
  {
    path: '/register',
    name: 'register',
    meta: {
      title: '注册',
      cName: '注册',
    },
    component: resolve => {
      require(['../views/login/register.vue'], resolve);
    }
  },
  {
    path: '/',
    name: '',
    redirect: '/index',
    component: main,
    children: [
      {
        path: '/index',
        name: 'index',
        component: resolve => {
          require(['../views/login/welcome.vue'], resolve);
        },
        meta: {
          title: '首页',
          cName: '首页',
        },
      },
      {
        path: '/welcome',
        name: 'welcome',
        meta: {
          title: '欢迎页',
          cName: '欢迎页',
        },
        component: resolve => {
          require(['../views/login/welcome.vue'], resolve);
        }
      },
      {
        path: '/403',
        name: '403',
        meta: {
          title: '无页面权限',
          cName: '403',
        },
        component: resolve => {
          require(['../views/sys/403.vue'], resolve);
        }
      },
      {
        path: '/404',
        name: '404',
        meta: {
          title: '无相应页面',
          cName: '404',
        },
        component: resolve => {
          require(['../views/sys/404.vue'], resolve);
        }
      },
      ...childenRoute,
    ]
  }
];



// WEBPACK FOOTER //
// ./src/router/router.js